// extracted by mini-css-extract-plugin
export default {"error":"Boundary_error__+wPLL","spinner":"Boundary_spinner__PXpN9"};